<template functional>
  <div>
    <a href="#" @click="$options.show(props)">{{ props.row.NcfMovilQty }}</a>
  </div>
</template>

<script>
import store from "../../../../store/index";
export default {
  name: "ncfmovilLink",
  show(ops) {
    store.dispatch("getAllTerminalAndServicesAsync", {
      Rnc: ops.row.Rnc,
      type: 1
    });
  }
};
</script>
